module.exports = __webpack_public_path__ + "static/media/Boldore_gaussian2.0241f3f6.png";